export default __webpack_public_path__ + "static/media/landing-1-circle-top-left.1264b7f1.svg";